// @flow
import * as React from 'react';
import { getAllUpcomingAuctionsUrl, getAuctionResultsUrl, getTodayUrl } from '../../../utils/urls';
import { faCalendarAlt } from '@fortawesome/pro-regular-svg-icons/faCalendarAlt';
import { faFire } from '@fortawesome/pro-regular-svg-icons/faFire';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';
import isEqual from 'react-fast-compare';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import SlideMenu from '@liveauctioneers/caterwaul-components/lib/SlideMenu/SlideMenu';
import styles from './MobileNavigation.module.scss';

type Props = {
    baseUrl: string,
    header: React.Node,
    trackPriceResultsClick: Function,
};

const MobileNavigation = ({ baseUrl, header, trackPriceResultsClick }: Props) => {
    return (
        <SlideMenu className={styles.sideBar} header={header}>
            <Link className={styles.link} route to={getTodayUrl()}>
                <FontAwesomeIcon icon={faFire} className={styles.icon} />
                <FormattedMessage id="trending_auctions" />
            </Link>
            <Link className={styles.link} route to={getAllUpcomingAuctionsUrl()}>
                <FontAwesomeIcon icon={faCalendarAlt} className={styles.icon} />
                <FormattedMessage id="auction_calendar" />
            </Link>
            <Link className={styles.link} route to="/find-auctions-near-me">
                <FormattedMessage id="auctions_near_me" />
            </Link>
            <Link className={styles.link} onClick={trackPriceResultsClick} route to={getAuctionResultsUrl()}>
                <FormattedMessage id="price_results" />
            </Link>
            <div preventclose="true" className={styles.divider} />
            <div preventclose="true" className={styles.categories}>
                <FormattedMessage id="navigation.categories" />
            </div>
            <Link className={styles.link} route to="/c/art/1/">
                <FormattedMessage id="navigation.art" />
            </Link>
            <Link className={styles.link} route to="/c/jewelry/6/">
                <FormattedMessage id="navigation.jewelry" />
            </Link>
            <Link className={styles.link} route to="/c/asian/158/">
                <FormattedMessage id="navigation.asian_antiques" />
            </Link>
            <Link className={styles.link} route to="/c/furniture/4/">
                <FormattedMessage id="navigation.furniture" />
            </Link>
            <Link className={styles.link} route to="/c/collectibles/2/">
                <FormattedMessage id="navigation.collectibles" />
            </Link>
            <Link className={styles.link} route to="/c/coins-currency-stamps/24/">
                <FormattedMessage id="navigation.coins" />
            </Link>
            <Link className={styles.link} route to="/c/memorabilia/26429/">
                <FormattedMessage id="navigation.memorabilia" />
            </Link>
            <Link className={styles.link} route to="/c/home-garden/5/">
                <FormattedMessage id="navigation.home_and_garden" />
            </Link>
            <Link className={styles.link} route to="/c/fashion/3/">
                <FormattedMessage id="navigation.fashion" />
            </Link>
            <div preventclose="true" className={styles.divider} />

            <Link className={styles.link} target="_blank" to="https://help.liveauctioneers.com/" rel="noopener">
                <FormattedMessage id="help" />
            </Link>
            <Link className={styles.link} target="_blank" to={`${baseUrl}/news/`}>
                <FormattedMessage id="news" />
            </Link>
            <Link className={styles.link} route to="/consignments">
                <FormattedMessage id="consign" />
            </Link>
        </SlideMenu>
    );
};

export default React.memo<Props>(MobileNavigation, isEqual);
